// extracted by mini-css-extract-plugin
module.exports = {"Icon":"DeleteMenuButton_Icon__9unTt"};